import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

interface Props {
  clickable?: boolean;
  items: Array<{ slug: string | null; color: string }>;
  large?: boolean;
  activeSimilarProduct?: { color: string } | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiColorSelect',
  props: {
    clickable: { type: Boolean, default: false },
    items: { default: () => [] },
    large: { type: Boolean, default: false },
    activeSimilarProduct: { default: null }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (e: 'input', value: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { clickable: boolean, items: Array<{ slug: string | null; color: string }>, large: boolean, activeSimilarProduct: { color: string } | null };




const activeColor = ref(
  props.activeSimilarProduct
    ? props.activeSimilarProduct.color
    : props.items[0]?.color,
);

const setColor = (color: string, index: number) => {
  if (props.clickable) return;

  if (activeColor.value === color) return;

  activeColor.value = color;
  emit('input', index);
};

return { __sfc: true,props, emit, activeColor, setColor }
}

})